import React from 'react'

function RepairServices() {
  return (
    <div className="container Detail">
    <h6>  Repair & Services</h6>
    <p>Here is the list of repair & service providers in Ethiopia...</p>
    </div>
  )
}

export default RepairServices;